import {PayloadAction} from '@reduxjs/toolkit';
import dpAssetsReducer from './dpAssets/dpAssets.slice';
import {DynamicParamsState} from './dynamicParams.types';

const dynamicParamsReducer = (
  state: DynamicParamsState,
  action: PayloadAction,
): DynamicParamsState => {
  const dpAssetsState = dpAssetsReducer(state?.dpAssets, action);

  return {
    dpAssets: dpAssetsState,
  };
};

export default dynamicParamsReducer;
